(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lrd-digital-storefront"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.lrd-storefront:not([data-lrd-ready])');
    roots.forEach((root) => {
      root.dataset.lrdReady = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('lrd-js');
      const items = root.querySelectorAll('.lrd-reveal');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
      items.forEach((item) => observer.observe(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrd-product-page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lrdp').forEach((productSection) => {
  const variantSelect = productSection.querySelector('[data-lrdp-variant-select]');
  const price = productSection.querySelector('[data-lrdp-price]');
  const compare = productSection.querySelector('[data-lrdp-compare]');
  const mobilePrice = productSection.querySelector('[data-lrdp-mobile-price]');

  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const nextPrice = option ? option.dataset.price : '';
      const nextCompare = option ? option.dataset.compare : '';

      if (nextPrice && price) price.textContent = nextPrice;
      if (nextPrice && mobilePrice) mobilePrice.textContent = nextPrice;

      if (compare) {
        if (nextCompare) {
          compare.textContent = nextCompare;
          compare.hidden = false;
        } else {
          compare.textContent = '';
          compare.hidden = true;
        }
      }
    });
  }
});

document.querySelectorAll('[data-lrdp-gallery]').forEach((gallery) => {
  const mediaWrap = gallery.closest('.lrdp__media-wrap');
  const mainImage = mediaWrap ? mediaWrap.querySelector('.lrdp__image') : null;
  const thumbs = gallery.querySelectorAll('[data-lrdp-thumb]');

  if (!mainImage || !thumbs.length) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');

      const nextSrc = thumb.dataset.src;
      const nextSrcset = thumb.dataset.srcset;
      const nextAlt = thumb.dataset.alt;

      if (nextSrc) mainImage.src = nextSrc;
      if (nextSrcset) mainImage.srcset = nextSrcset;
      if (nextAlt) mainImage.alt = nextAlt;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrd-smart-business-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.smbp').forEach((root) => {
  const variant = root.querySelector('[data-smbp-variant]');
  const price = root.querySelector('[data-smbp-price]');
  const compare = root.querySelector('[data-smbp-compare]');

  if (variant) {
    variant.addEventListener('change', () => {
      const option = variant.options[variant.selectedIndex];
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        if (option?.dataset.compare) {
          compare.textContent = option.dataset.compare;
          compare.hidden = false;
        } else {
          compare.textContent = '';
          compare.hidden = true;
        }
      }
    });
  }

  const gallery = root.querySelector('[data-smbp-gallery]');
  const image = root.querySelector('.smbp__image');
  if (gallery && image) {
    gallery.querySelectorAll('[data-smbp-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        gallery.querySelectorAll('[data-smbp-thumb]').forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
        if (thumb.dataset.src) image.src = thumb.dataset.src;
        if (thumb.dataset.srcset) image.srcset = thumb.dataset.srcset;
        if (thumb.dataset.alt) image.alt = thumb.dataset.alt;
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrd-solution-finder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-lrdf]').forEach((finder) => {
  const choices = finder.querySelectorAll('[data-lrdf-choice]');
  const title = finder.querySelector('[data-lrdf-title]');
  const text = finder.querySelector('[data-lrdf-text]');
  const link = finder.querySelector('[data-lrdf-link]');
  const linkLabel = finder.querySelector('[data-lrdf-link-label]');

  choices.forEach((choice) => {
    choice.addEventListener('click', () => {
      choices.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      choice.classList.add('is-active');
      choice.setAttribute('aria-pressed', 'true');

      if (title) title.textContent = choice.dataset.title || '';
      if (text) text.textContent = choice.dataset.text || '';
      if (link) link.setAttribute('href', choice.dataset.url || '#');
      if (linkLabel) linkLabel.textContent = choice.dataset.label || '';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
